import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AirIcon(props: IconProps) {
    return <Icon {...props} iconKey={"air"}/>
}
